const FEATUREBASE_JWT_ENDPOINT =
  'https://griply.featurebase.app/api/v1/auth/access/jwt';

export const constructFeaturebaseJwtUrl = (
  jwtToken: string,
  returnToUrl: string,
): string => {
  const params = new URLSearchParams({
    jwt: jwtToken,
    return_to: returnToUrl,
  });

  return `${FEATUREBASE_JWT_ENDPOINT}?${params.toString()}`;
};
